/*
 * Copyright (c) Siemens Energy AG 2020 ALL RIGHTS RESERVED
 * I&C Monitors and Advisors (ICMA)
 */
import React from 'react';

export default class NavigationBarComponent extends React.Component {
  render() {
    let services = this.props.services;
    let selectedUseCase = this.props.selectedUseCase;
    if (services) {
      let accordions = services.map((service) => {
        let usecases = service.usecases.map((usecase) => {
          let serviceUsacase =
            service.service.toString() + usecase.usecase.toString();
          return (
            <NavigationBarElement
              selectedUseCase={selectedUseCase}
              serviceUsacase={serviceUsacase}
              usecaseName={usecase.name}
              usecaseId={usecase.usecase}
              serviceId={service.service}
              key={usecase.usecase}
              handler={this.props.onUsecaseSelect}
            ></NavigationBarElement>
          );
        });

        return (
          <div className="accordion" key={`accordion-${service.service}`}>
            <h2 className="application-header-ah3 closed dls-cs-accordion-h2">
              {service.name}
            </h2>
            <div
              className="accordion-content dls-cs-accordion"
              style={{ display: 'none' }}
              id={service.service}
            >
              {usecases}
            </div>
          </div>
        );
      });

      return (
        <div className="dls-cs-sidebar">
          <div>
            <h2 className="dls-cs-margin-bottom">Plant Settings</h2>
            {accordions}
          </div>
        </div>
      );
    } else {
      return (
        <div className="dls-cs-sidebar">
          <div>
            <h2 className="dls-cs-margin-bottom">Plant Settings</h2>
            <h4 className="dls-cs-margin-bottom">Loading...</h4>
          </div>
        </div>
      );
    }
  }
}

const NavigationBarElement = (props) => {
  return (
    <div
      className={
        props.selectedUseCase === props.serviceUsacase
          ? 'dls-cs-accordion-element  dls-cs-activeMenu'
          : 'dls-cs-accordion-element '
      }
      style={{ padding: '10px' }}
      onClick={(e) => props.handler(props.serviceId, props.usecaseId)}
    >
      {props.usecaseName}
    </div>
  );
};
